import { styled } from '@mui/material';

const StyledAppointmentsBookingModalForm = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
});

export default StyledAppointmentsBookingModalForm;
